import { Component, Input, Renderer } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { AbstractFormComponent } from '../../../../core/abstract-form-component';
import { declineDialogValidationMessages, getdeclineDialogControlsConfig } from './decline.dialog.form';
import { DeclineDialogContractStateService } from './decline.dialog.state.service';
import { ForSigningHttpService } from '../../../../services/forsigning/forsigning.http.service';
import { StorageUtil } from '../../../../utils/storage.util';
import { ForSigningHttpUtil } from '../for-signing.util';
import { AuthUtil } from '../../../../utils/auth.utils';
import { Router } from '@angular/router';

@Component({
  moduleId: module.id,
  selector: 'bft-decline-dialog-contract',
  templateUrl: 'decline.dialog.component.html',
  styleUrls: ['decline.dialog.component.css'],
  providers: []
})

export class DeclineComponent extends AbstractFormComponent {

  @Input()
    epId;

  chatTypeList = [{label: 'Вопрос куратору', value: '1'}];
  model = {
    message: '',
    epId: this.epId,
  };
  attachment;
  displayDialog: boolean = false;
  loading: boolean = false;
  errorMessage = '';
  successMessage = '';

  isAttached = false;

  constructor(private declineDialogContractStateService: DeclineDialogContractStateService,
              private formBuilder: FormBuilder,
              private forSigningHttpService: ForSigningHttpService,
              private authUtil: AuthUtil,
              private router: Router,
              private renderer: Renderer,
  ) {
    super();

    this.declineDialogContractStateService.handleDialogStatus().subscribe(data => {
      this.displayDialog = data.display;
      this.isAttached = false;
      this.attachment = '';
      this.errorMessage = '';
      this.form.reset();
      this.model = {
        message: '',
        epId: this.epId,
      };
      this.form.patchValue(this.model);
    });

  }

  buildForm(): FormGroup {
    return this.formBuilder.group(getdeclineDialogControlsConfig(this.model, this.formBuilder));
  }

  getValidationMessages(): {} {
    return declineDialogValidationMessages;
  }

  submit() {
    this.loading = true;
    delete this.errorMessage;
    delete this.successMessage;

    let data = {
      securityToken: StorageUtil.getToken(),
      message: this.form.value.message
    };
    let requestParams = ForSigningHttpUtil.prepareParamsDecline(data);
    this.forSigningHttpService.postDeclineContract(this.epId, requestParams).subscribe(
      success => {
        if (success) {
          this.loading = false;
          this.displayDialog = false;
          window.location.reload();
          this.authUtil.checkErrorResponse(success.json());
        }
      },
      error => {
        this.errorMessage = 'Произошла ошибка.';
        this.loading = false;
      },
      () => {
        this.loading = false;
      });
  }

  close($event) {
    $event.preventDefault();
    this.displayDialog = false;
    this.attachment = '';
  }

  findAncestor (el, cls) {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
  }

  onFocus($event) {
    let element = this.findAncestor($event.target, 'topic-hold');
    this.renderer.setElementClass(element, 'focus', true);
  }

  onBlur($event) {
    let element = this.findAncestor($event.target, 'topic-hold');
    this.renderer.setElementClass(element, 'focus', false);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/for-signing/decline/decline.dialog.component.ts